module.exports = __webpack_public_path__ + "img/NEW LOGO TED.11e7b645.png";